module.exports = __webpack_public_path__ + "static/media/logo-koki.d915f5e1.svg";